module.exports = __webpack_public_path__ + "static/capture_widgets-beb172f420855b03cf4bf4177eff1586.png";